module.exports = "/_next/static/images/c697381dbf7e0bb86e7e58c9dc1280cc-card-background-left-lg.jpg.webp";